import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Switch, Tooltip, useTheme } from "@mui/material";
import { useMediaDevices } from "@dvrt/web-phone-client";
import { useForcedValidMediaSettings, useSettings } from "../tools";
import { defineMessage, FormattedMessage } from "react-intl";

const disabledIconOpacity = 0.3;

const stateMessage = defineMessage({
    id: "deviceSelectorWidget.state",
    defaultMessage: "Your {name} is {on, plural, =0 {off} other {on}}",
});

const switchMessage = defineMessage({
    id: "deviceSelectorWidget.switch",
    defaultMessage: "Turn {on, plural, =0 {on} other {off}} your {name}",
});

export default function Widget({ allowUnmute }: { allowUnmute?: boolean }) {
    const mediaDevices = useMediaDevices();
    const settings = useSettings();
    const theme = useTheme();

    useForcedValidMediaSettings();

    const audioDisabled =
        !mediaDevices.capabilities.audioinput || (!settings.audio && allowUnmute !== undefined && !allowUnmute);

    return (
        <>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Tooltip
                    title={
                        <FormattedMessage
                            {...stateMessage}
                            values={{ on: settings.audio ? 1 : 0, name: "microphone" }}
                        />
                    }
                    arrow
                >
                    <label htmlFor="audioSwitch">
                        <FontAwesomeIcon
                            icon={settings.audio ? "microphone" : "microphone-slash"}
                            size="lg"
                            color={settings.audio ? theme.palette.primary.main : "inherit"}
                            style={{ opacity: !audioDisabled ? 1 : disabledIconOpacity }}
                        />
                    </label>
                </Tooltip>
                <Tooltip
                    title={
                        <FormattedMessage
                            {...switchMessage}
                            values={{ on: settings.audio ? 1 : 0, name: "microphone" }}
                        />
                    }
                    arrow
                >
                    <Switch
                        id="audioSwitch"
                        checked={settings.audio}
                        color="primary"
                        disabled={audioDisabled}
                        onChange={() => {
                            settings.audio = !settings.audio;
                        }}
                    />
                </Tooltip>

                <Tooltip
                    title={
                        <FormattedMessage {...stateMessage} values={{ on: settings.video ? 1 : 0, name: "camera" }} />
                    }
                    arrow
                >
                    <label htmlFor="videoSwitch">
                        <FontAwesomeIcon
                            icon={settings.video ? "video" : "video-slash"}
                            size="lg"
                            color={settings.video ? theme.palette.primary.main : "inherit"}
                            style={{
                                marginLeft: "0.5em",
                                opacity: mediaDevices.capabilities.videoinput ? 1 : disabledIconOpacity,
                            }}
                        />
                    </label>
                </Tooltip>
                <Tooltip
                    title={
                        <FormattedMessage {...switchMessage} values={{ on: settings.video ? 1 : 0, name: "camera" }} />
                    }
                    arrow
                >
                    <Switch
                        id="videoSwitch"
                        checked={settings.video}
                        color="primary"
                        disabled={!mediaDevices.capabilities.videoinput}
                        onChange={() => {
                            settings.video = !settings.video;
                        }}
                    />
                </Tooltip>
            </div>
        </>
    );
}
